import { Image, Text } from "@tblabs/truffle";
import { Box } from "../../../Components/Utils/Box";
import { ProductCategory } from "../../../Models/Product/ProductCategory";


export class CategoryEditTitle extends Box
{
    constructor(x: ProductCategory)
    {
        super(
            new Image(x.Image).Class("category-edit-box-image"),
            new Text(x.Title).Class("category-edit-box-title")
        );
    }
}
